export const telFormatter = (data: string) => {
  if (!data) return '';

  const number = data.replaceAll('-', '');
  switch (number.length) {
    case 5:
      return `${number.substring(0, 2)}-${number.substring(2, 5)}`;
    case 6:
      return `${number.substring(0, 3)}-${number.substring(3, 6)}`;
    case 8:
      return `${number.substring(0, 4)}-${number.substring(4, 8)}`;
    case 9:
      return `${number.substring(0, 2)}-${number.substring(
        2,
        5
      )}-${number.substring(5, 9)}`;
    case 10:
      return `${number.substring(0, 2)}-${number.substring(
        2,
        6
      )}-${number.substring(6, 10)}`;
    case 11:
      return `${number.substring(0, 3)}-${number.substring(
        3,
        7
      )}-${number.substring(7, 11)}`;
    default:
      return data;
  }
};
